// Import necessary functions from Redux Toolkit and axios for HTTP requests
import { createSlice } from "@reduxjs/toolkit";
import { fetchUserData, registerToBectran } from "reduxStore/apis/index";

export const initialState = {
  isAuthenticated: false,
  userDatafetched: false,
  accessToken: null,
  user: null,
  error: null,
  success: null,
  info: null,
  warning: null,
  registrationStatus: null,
  initLoading: true,
  loading: false,
  loadingMessage: null,
  fetchingData: false,
  fetchedData: false,
  redirectUser: false,
  omsValidation: {
    onGoing: true,
    success: false,
    error: false,
    errorMessage: null,
    contractNoSelected: false,
    contractNo: null,
    invoiceNoSelected: true,
    invoiceNo: null,
    mail: null
  },
  tnc: {
    onGoing: true,
    accepted: false,
    email: null
  }
};
// Create a slice for authentication state management
const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    authSuccess: (state, action) => ({
      ...state,
      isAuthenticated: true,
      error: null,
      accessToken: action.payload?.accessToken,
    }),
    authFailure: (state, action) => ({
      ...state,
      error: action.payload,
      loading: false,
      loadingMessage: null,
    }),
    setOmsValidation: (state, action) => ({
      ...state,
      omsValidation: {
        ...state.omsValidation,
        ...action.payload
      }
    }),
    setTnc: (state, action) => ({
      ...state,
      tnc: {
        ...state.tnc,
        ...action.payload
      }
    }),
    setLoadingMessage: (state, action) => ({
      ...state,
      loadingMessage: action.payload
    }),
    // Reducer for successful login
    loginSuccess: (state, action) => ({
      ...state,
      isAuthenticated: true,
      user: action.payload,
      error: null,
    }),
    // Reducer for successful logout
    logoutSuccess: (state) => ({
      ...initialState,
      initLoading: false
    }),

    // setAuth
    setAuth: (state, action) => ({
      ...state,
      isAuthenticated: action.payload,
    }),
    setInitLoading: (state, action) => ({
      ...state,
      initLoading: action.payload,
    }),
    setLoading: (state, action) => ({
      ...state,
      loading: action.payload,
    }),
    setAccount: (state, action) => ({
      ...state,
      user: {
        ...state.user,
        BillToAccount: action.payload
      }
    })
  },
  // Extra reducers for handling async thunk actions
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserData.pending, (state) => {
        return {
          ...state,
          loadingMessage: "Signing In",
          fetchingData: true,
        };
      })
      .addCase(fetchUserData.fulfilled, (state, action) => {
        if (action.payload.error) {
          return {
            ...state,
            error: action.payload.error,
            initLoading: false,
            loading: false,
            loadingMessage: null,
            fetchingData: false,
            fetchedData: true
          };
        }
        const newState = {
          ...state,
          user: action.payload.response,
          userDatafetched: true,
          isAuthenticated: true,
          accessToken: action.payload.accessToken,
          error: null,
          loading: false,
          loadingMessage: null,
          fetchingData: false,
          fetchedData: true
        };
        if (state.initLoading) newState.initLoading = false;
        return newState;
      })
      // Handle failed user data fetch
      .addCase(fetchUserData.rejected, (state, action) => {
        const newState = {
          ...state,
          error: action.payload,
          loading: false,
          loadingMessage: null,
          fetchingData: false,
          fetchedData: true
        };
        if (state.initLoading) newState.initLoading = false;
        return newState;
      }).addCase(registerToBectran.pending, (state) => {
        return {
          ...state,
          loadingMessage: "Signing In to Bectran",
          loading: true,
        };
      })
      .addCase(registerToBectran.fulfilled, (state, action) => {
        if (action.payload.error) {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
            loadingMessage: null,
            redirectUser: false,
          };
        }
        return {
          ...state,
          error: null,
          loadingMessage: "Redirecting to Bectran Portal",
          redirectUser: true,
        };
      })
      // Handle failed user data fetch
      .addCase(registerToBectran.rejected, (state, action) => {
        return {
          ...state,
          error: action.payload.error,
          loading: false,
          loadingMessage: null,
          redirectUser: false,
        };
      });
  },
});

// Export action creators
export const {
  loginSuccess,
  logoutSuccess,
  setAuth,
  setInitLoading,
  setLoading,
  authSuccess,
  authFailure,
  setLoadingMessage,
  setOmsValidation,
  setTnc,
  setAccount
} = authSlice.actions;
// Export the reducer
export default authSlice.reducer;
